import React, {useCallback} from 'react';

export const useSlotDrop = ({
    sampleDragging,
    slotNumber,
    slot,
    pad,
    sampleTagDragging,
    setSampleDragging,
    setSampleTagDragging,
    setTrackDragging,
    trackDragging
}) => {
    const onDrop = useCallback((e) => {
        e.stopPropagation();
        pad.sequencerEngine.switchToSubSequence(pad.subSequence.id);
        if (trackDragging) {
            if (pad.tracks.includes(trackDragging)) {
                pad.switch(slotNumber, pad.tracks.indexOf(trackDragging));
            } else {
                pad.addTrack(trackDragging, slotNumber);
            }
        } else if (sampleDragging) {
            let track = pad.containsSample(sampleDragging);
            if (track) {
                pad.switch(slotNumber, pad.tracks.indexOf(track));
            } else {
                // then check if any of the tracks conntain this sample
                for (let track of pad.subSequence.tracks) {
                    if (!track.isFrozen && track.sample === sampleDragging) {
                        // if there are no steps then we want to match then
                        // length of the pads patterns
                        let matchLens = track.getEasyPattern().getAllSteps().length === 0;
                        pad.addTrack(track, slotNumber, matchLens);
                        setSampleDragging(undefined);
                        return;
                    }
                }
                if (pad.slots[slotNumber]) {
                    if (!sampleDragging.audioBuffer) {
                        sampleDragging.load().then(
                            x => pad.slots[slotNumber].useNewSound(sampleDragging));
                    } else {
                        pad.slots[slotNumber].useNewSound(sampleDragging);
                    }
                } else {
                    pad.newSample(sampleDragging, slotNumber);
                }
            }
        } else if (sampleTagDragging) {
            let sequencerEngine = pad.sequencerEngine;
            let tags = sequencerEngine.state.selector.sampleTagDragging;
            if (!Array.isArray(tags)) {
                tags = [tags];
            }
            sequencerEngine.searchForSounds(
                tags,
                slot,
                slot,
                undefined,
                false
            )
                .then(track => {
                    if (!slot) {
                        pad.addTrack(track, slotNumber, true);
                    }
                });
            setSampleTagDragging(undefined);
        }
        setTrackDragging(undefined);
        setSampleDragging(undefined);
        setTrackDragging(undefined);
    }, [
        sampleDragging,
        slot,
        slotNumber,
        pad,
        sampleTagDragging,
        trackDragging,
        setTrackDragging
    ]);

    return {onDrop};
};
